<template>
  <v-container fluid>
    <div id="app">
      <v-app id="inspire">
        <!--Signing Title-->
        <v-layout row wrap>
          <v-row align="center" justify="center">
            <v-col cols="auto" md="auto">
              <v-flex sm="15">
                <h1>Welcome Back!</h1>
              </v-flex>
            </v-col>
          </v-row>
        </v-layout>

        <!--Error Alert-->
        <v-layout v-if="error">
          <v-flex xs12 sm6 offset-sm3>
            <form-alert :message="error.message"> </form-alert>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm6 offset-sm3>
            <v-card color="secondary" dark max-width="344" class="mx-auto">
              <v-container>
                <v-form
                  v-model="isFormValid"
                  lazy-validation
                  ref="form"
                  @submit.prevent="handleSigninUser"
                >
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="userEmailRules"
                        autocomplete="email"
                        v-model="userEmail"
                        prepend-icon="mail"
                        label="User Email"
                        type="text"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="passwordRules"
                        v-model="password"
                        autocomplete="password"
                        prepend-icon="extension"
                        label="Password"
                        type="password"
                        required
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-btn
                        :loading="loading"
                        :disabled="!isFormValid || loading"
                        color="accent"
                        type="submit"
                        data-cy="signInButton"
                      >
                        <span slot="loader" class="custom-loader">
                          <v-icon light>cached</v-icon>
                        </span>
                        Signin
                      </v-btn>
                      <!-- <v-btn @click="authenticate('facebook')">Facebook
                         <span slot="loader" class="custom-loader">
                               <v-icon light>facebook-box</v-icon>
                         </span>
                         </v-btn>
<v-btn @click="authenticate('google')">Google</v-btn> -->
                      <v-btn
                        v-for="(social, index) in items"
                        :key="index"
                        class="mx-3"
                        dark
                        icon
                        @click="authenticate(social.provider)"
                      >
                        <v-icon size="18px">{{ social.icon }}</v-icon>
                      </v-btn>

                      <h3>
                        Don't have an account?
                        <router-link to="/auth/signup">Signup</router-link>
                      </h3>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
//import router from "../../router.js";

export default {
  data() {
    return {
      userEmail: "",
      password: "",
      isFormValid: true,
      userEmailRules: [
        userEmail => !!userEmail || "User Email is required",
        userEmail =>
          userEmail.length < 50 || "User Email must be less than 50 characters"
      ],
      passwordRules: [
        password => !!password || "Password is required",
        password =>
          password.length >= 4 || "Password must be at least 4 characters"
      ],
      items: [
        { icon: "fab fa-facebook", provider: "facebook" },
        { icon: "fab fa-twitter", provider: "twitter" },
        { icon: "fab fa-google", provider: "google" },
        { icon: "fab fa-github", provider: "github" }
        //  { icon: "fab fa-instagram", link: "" },
        //  { icon: "fab fa-linkedin", link: "" },
        //  { icon: "fab fa-google-plus", link: "" },
      ]
    };
  },

  computed: {
    ...mapGetters(["loading", "error", "user", "isAuthenticated"])
  },

  watch: {
    user(value) {
      // if user value changes and redirect is populated - redirect to redirect page, otherwise to home lib page

      var redir_path = !this.$route.query.redirect
        ? "/"
        : this.$route.query.redirect;
      if (value) {
        this.$router.push(redir_path);
      }
    }
  },
  methods: {
    handleSigninUser() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("signInUser", {
          userEmail: this.userEmail,
          password: this.password
        });
      }
      //reach out of Vuex store, fire action that gets Clubs
      this.$store.dispatch("allClubs", {});
    }
    //, authenticate(provider) {

    //   this.$auth.authenticate(provider).then(function() {

    //   })
    // },
    // login () {
    //   this.$store.dispatch('login', { user, requestOptions })
    // }
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
